

































































import { cloneDeep } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../components/Pi/index'
import { FieldData } from '../../../../../../components/Pi/types'
import { errorNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import PostApi from '../../../../includes/logic/Api/PostApi'
import BusinessRegistrationEmailValidationIcon
  from '../components/BusinessRegistrationEmailValidationIcon.vue'
import { CompanyData, CompanyRegistrationStep } from '../types'

@Component({
  components: {
    BusinessRegistrationEmailValidationIcon,
    ValidationObserver,
  },

  data: () => ({
    CompanyRegistrationStep,
  }),
})
export default class EmailValidation extends Mixins<UseFields>(UseFields) {
  @Prop() readonly value!: CompanyData

  isLoading = false

  get companyData(): CompanyData {
    return cloneDeep(this.value)
  }

  inputConfigSetup(args: FieldData): FieldData {
    args.setter = (value: any): void => {
      this.$set(args.model, args.key as string, value)
    }

    return args
  }

  @Emit()
  input(): CompanyData {
    return this.companyData
  }

  @Emit()
  next(): { step: CompanyRegistrationStep } {
    return { step: CompanyRegistrationStep.FinishRegistration }
  }

  successMessage(title: string, text: string): void {
    this.$notification.success({
      message: title,
      description: text,
      placement: 'bottomRight',
      class: 'successNotification',
    })
  }

  async onNextButtonClick(): Promise<void> {
    this.input()

    const fd: FormData = new FormData()
    fd.append('questionnaire', JSON.stringify(this.companyData.company))
    fd.append('document', this.companyData.document as File, this.companyData.document?.name)
    try {
      this.isLoading = true
      await PostApi.sendRequest('tg', 'createorganization', fd)
      this.next()
    } catch (error: any) {
      errorNotificationWrapper(this.$t('error').toString(), error)
    } finally {
      this.isLoading = false
    }
  }

  async sendCodeToEmail(): Promise<void> {
    try {
      this.isLoading = true
      await PostApi.sendRequest('tg', 'validateorganizationemail', { email: this.companyData.company.email })
      this.successMessage(
        this.$t('company_registration_step_email_validation_send_code_success_title') as string,
        this.$t('company_registration_step_email_validation_send_code_success_text') as string,
      )
    } catch (error: any) {
      errorNotificationWrapper(this.$t('error').toString(), error)
    } finally {
      this.isLoading = false
    }
  }
}
